<template>
  <v-app-bar
    absolute
    app
    flat
    height="75"
    style="width: auto;"
  >
    <v-btn
      fab
      text
      class="d-sm-flex d-md-none"
      @click="setDrawer(!drawer)"
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>

    <v-autocomplete
      v-model="model"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      :class="{'search-width': !$vuetify.breakpoint.smAndDown }"
      no-filter
      :menu-props="{ closeOnContentClick: true }"
      hide-details
      hide-selected
      :hide-no-data="isLoading"
      item-text="name"
      item-value="id"
      placeholder="Search"
      id="topSearch"
      prepend-icon="mdi-magnify"
      solo
      flat
      @focusin="handleFocusChange"
      @focusout="handleFocusChange"
      style="background-color: transparent !important;"
    >
    <!-- class="hidden-sm-and-down mb-2 mr-8" -->
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>
            Search for 
            <strong><router-link to="/stocks/list">Stocks</router-link>/<router-link to="/investors/list">Investors</router-link>/<router-link to="/portfolio/list">Portfolio</router-link></strong>
          </v-list-item-title>
        </v-list-item>
      </template>

      <template v-slot:item="{ item }">
        <v-list-item :to="pathToItem(item)">        
          <v-list-item-icon>
                <v-chip :style="'background-color: ' + item.color + ' !important;'"  small>{{item.type}}</v-chip>
          </v-list-item-icon>        
          <v-list-item-content>
            <v-list-item-title v-text="item.name"></v-list-item-title>
            <v-list-item-subtitle v-text="item.code"></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>mdi-magnify</v-icon>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-autocomplete>

    <v-spacer />

    <template
      v-if="!isFullSearchBar"
    >
      <v-tooltip
        bottom
      >
        <template v-slot:activator="{ on }">

          <v-btn
            min-width="0"
            id="addPortfolio"
            text
            to="/portfolio/add"
            v-on="on"
            class="hidden-sm-and-down"
          >
            <v-icon>mdi-plus</v-icon>
            <p>Portfolio</p>
          </v-btn>                          
        </template>                      
        <span>Add a Portfolio</span>
      </v-tooltip> 

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            min-width="0"
            id="Likes"
            text
            to="/likes"
            v-on="on"      
          >
            <v-icon>mdi-heart</v-icon>
            <p class="hidden-sm-and-down">Likes</p>
          </v-btn>                         
        </template>                      
        <span>Manage your stocks preferences</span>
      </v-tooltip> 


      <!-- <v-btn
        min-width="0"
        text
      >
        <v-icon>mdi-cogs</v-icon>
        <p class="hidden-sm-and-down">Settings</p>
      </v-btn> -->

      <v-btn
        min-width="0"
        text
        @click="signOut"
        v-if="signedIn"
        class="hidden-sm-and-down"
      >
        <v-icon>mdi-logout-variant</v-icon>
        <p>Log out</p>
      </v-btn>
      
      <v-menu
        bottom
        left
        offset-y
        origin="top right"
        transition="scale-transition"
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            min-width="0"
            text
            v-bind="attrs"
            v-on="on"
            @click="messages=0"
          >
            <v-badge 
              :value="messages"          
              color="red"
              overlap
            >
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>

        <v-list
          :tile="false"
          nav
        >
          <div>
            <app-bar-item
              v-for="(n, i) in notifications"
              :key="`item-${i}`"
            >
              <v-list-item-title v-text="n" />
            </app-bar-item>
          </div>
        </v-list>
      </v-menu>

    </template>
  </v-app-bar>
</template>

<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'

  // Utilities
  import { mapState, mapMutations } from 'vuex'

  import { AmplifyEventBus } from "aws-amplify-vue"



  export default {
    name: 'DashboardCoreAppBar',

    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
      
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      //Amplify Auth
      messages: 0,      
      signedIn: false,
      //Notification system - TODO
      notifications: [
        'We have no notification'
      ],
      // Autocomplete
      isLoading: false,
      items: [],
      model: null,
      search: null,
      isSearchInputFoocused: false,
    }),

    async beforeCreate() {
      try {
        await this.$Amplify.Auth.currentAuthenticatedUser();
        this.signedIn = true;
      } catch (err) {
        this.signedIn = false;
      }
      AmplifyEventBus.$on("authState", info => {
        this.signedIn = info === "signedIn";
      });
    },

    computed: {
      ...mapState(['drawer']),
      isFullSearchBar () {
        return this.$vuetify.breakpoint.smAndDown && this.isSearchInputFoocused
      }
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
      handleFocusChange (e) {
        this.isSearchInputFoocused = e.target === document.activeElement
      },
      signOut: function() {
        this.$Amplify.Auth.signOut()
          .then(() => {
            this.$router.push('/login')
            return AmplifyEventBus.$emit('authState', 'signedOut')
          })
      },
      async getSearchFromApi (search) {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        //console.log(search)
        this.$http.post(process.env.VUE_APP_API_HOST + '/search-bar',{filter: search},{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.items = response.data
        }).catch(function (/*err*/) {
          //console.log(err)
        }).finally(() => (this.isLoading = false))    
      },
      navigateToItem (item) {
        if (item.type =="stock") {
          this.$router.push({ path: `/stocks/analyze/${item.id}` })
        }
        else if (item.type =="portfolio") {
          this.$router.push({ path: `/portfolio/analyze/${item.id}` })
        }
        if (item.type =="investor") {
          this.$router.push({ path: `/investors/analyze/${item.id}` })
        }                
      },
      pathToItem (item) {
        if (item.type =="stock") {
          return `/stocks/analyze/${item.id}`
        }
        else if (item.type =="portfolio") {
          return `/portfolio/analyze/${item.id}`
        }
        if (item.type =="investor") {
          return `/investors/analyze/${item.id}`
        }                
      },      
      fetchEntriesDebounced() {
        // cancel pending call
        clearTimeout(this._timerId)

        // delay new call 500ms
        this._timerId = setTimeout(() => {
          this.getSearchFromApi (this.search) 
        }, 500)
      },    
      customFilter (/*item, queryText, itemText*/) {
        // const textOne = itemText ? itemText.toLowerCase() : "";
        // const textTwo = item.code ? item.code.toLowerCase() : "" ;
        // const searchText = queryText ? queryText.toLowerCase(): "";        
        return 1;
        // return textOne.indexOf(searchText) > -1 ||
        //   textTwo.indexOf(searchText) > -1
      },      
    },
    //Watch used for search bar
    watch: {
      model (val) {
        if (val != null) this.tab = 0
        else this.tab = null
      },
      search () {
        // Items have already been loaded
        //if (this.items.length > 0) return
        this.isLoading = true

        // post /get-stocks-search
        this.fetchEntriesDebounced()
        
        // Lazily load input items
        // fetch('https://api.coinmarketcap.com/v2/listings/')
        //   .then(res => res.json())
        //   .then(res => {
        //     this.items = res.data
        //   })
        //   .catch(err => {
        //     console.log(err)
        //   })
        //   .finally(() => (this.isLoading = false))
      },
    },    
  }
</script>

<style lang="sass">
  .search-width
    max-width: 400px

  .v-badge__badge
    height: 5px
    min-width: 5px
    padding: 6px 6px
    
  .v-toolbar__content .v-btn--flat
    p
      margin-bottom: 0px
    .v-icon
      font-size: 20px
      top: 0
      position: relative
      margin-right: 3px

  .v-btn--fab.v-size--small .v-icon
    height: 20px
    font-size: 20px
    min-width: 20px
</style>